// extracted by mini-css-extract-plugin
module.exports = {"grid":"TileList_grid_1VRUN","large":"TileList_large_j6hEY"};